/* ============================================================================
   olmia-wishlist-page.js — tekent het verlanglijstraster op /pages/verlanglijst.

   DE POORT KOMT VAN DE SERVER (herbouwd 2026-08-20, ROADBLOCKS #74)
   -----------------------------------------------------------------------------
   Dit bestand bouwde de kaarten vroeger ZELF, uit de momentopname die bij de
   hartklik in localStorage was gezet. Die momentopname droeg de prijs, de
   klantprijs en de tier-beslissing van dát moment, en werd nooit herzien:

     r87 (oud)  var priceHidden = (snap.price == null);
     r79 (oud)  var quoteGate  = snap.priceOnRequest === true || loggedIn;

   Gevolg, gereproduceerd langs de natuurlijkste route die deze winkel heeft: een
   gast bewaart UR15 op /collections/cobots (gastenmuur → `price: null`, correct),
   logt daarna in, en leest op zijn verlanglijst "Prijs op aanvraag · Offerte" →
   /pages/contact — voor een ACTIEF, gepubliceerd, gewoon geprijsd product zonder
   `custom.price_on_request`, waarvan dezelfde klant op /products/ur15 gewoon het
   bedrag ziet. Andersom bleef een oude momentopname de publieke prijs én een
   `data-cust` (de B2B-inkoopprijs) in de DOM zetten, óók voor een gast. De
   gemeten bedragen staan in ROADBLOCKS #74 — niet hier: dit bestand is een asset
   en staat zonder sessie op de CDN (ROADBLOCKS #27).

   Nu haalt `render()` elke kaart op bij de server:
       GET /products/<handle>?section_id=wishlist      (Section Rendering API)
   `sections/wishlist.liquid` rendert dan één `snippets/product-card.liquid` —
   dezelfde en enige prijspoort van deze winkel (QUOTE > STRICT > SOFT), vers per
   paginabezoek. Er is geen tweede prijslogica meer in dit bestand, en er staat
   geen bedrag meer in localStorage.

   Kent de winkel de handle niet (verwijderd of verzonnen product), dan komt er
   geen `.pcard` terug; het item verdwijnt dan uit de lijst via OlmiaWishlist.prune.

   WAT ER NOG WÉL CLIENT-SIDE BESLIST WORDT: niets over afschermen — alleen een
   FAIL-CLOSED backstop (`scrubGate`). Die kan uitsluitend méér afschermen, nooit
   iets onthullen, en gebruikt exact dezelfde teksten en bestemmingen als de kaart:
     priceOnRequest → "Prijs op aanvraag" → /pages/contact
     gast           → "Log in voor prijzen" → /account/login
   Zelfde patroon als de `guestWall`-backstop in assets/olmia-keuzehulp.js.
   ========================================================================== */
/* TOESTEMMING (gemeten 2026-08-19): deze pagina leest uitsluitend via
   window.OlmiaWishlist en raakt localStorage nooit rechtstreeks aan. De
   onderbouwing en de bewaartermijn staan in assets/olmia-wishlist.js. */
(function () {
  'use strict';

  var ACCOUNT_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></svg>';
  // Vertaalbare teksten (window.olmiaT uit de layout); de tweede parameter is de Nederlandse terugval.
  var T = function (k, f) { return window.olmiaT ? window.olmiaT(k, f) : f; };
  var MAX_PARALLEL = 4;   // de winkel gaf 429 bij te veel gelijktijdige verzoeken

  function esc(v) {
    return String(v == null ? '' : v)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function grid() { return document.getElementById('wishGrid'); }
  function handles() {
    var list = (window.OlmiaWishlist && OlmiaWishlist.items()) || [];
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var h = list[i] && list[i].handle;
      if (h && out.indexOf(h) === -1) out.push(h);
    }
    return out;
  }

  /* ---------------- server card fetch ---------------- */
  /* De HTML per handle wordt voor de duur van deze pagina onthouden: een hartklik
     her-rendert het raster, en dan hoeven de overgebleven kaarten niet opnieuw
     opgehaald te worden. Een paginabezoek is de vernieuwingsgrens — de poort mag
     nooit langer meegaan dan één render van de server. */
  var cache = Object.create(null);

  function cardUrl(handle) {
    var tpl = (grid() && grid().dataset.cardUrl) || '/products/__HANDLE__?section_id=wishlist';
    return tpl.replace('__HANDLE__', encodeURIComponent(handle));
  }

  function fetchCard(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch(cardUrl(handle), { headers: { Accept: 'text/html' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card = doc.querySelector('.pcard[data-product]');
        if (!card) return null;                       // product bestaat niet (meer)
        /* De kaart moet ook echt OVER DIT PRODUCT gaan. Zonder deze controle zou
           een onverwacht antwoord (redirect naar een ander product, een
           foutpagina met een kaart erin) stilzwijgend het verkeerde artikel op de
           verlanglijst zetten. */
        var got = null;
        try { got = JSON.parse(card.getAttribute('data-product')).handle; } catch (e) { got = null; }
        if (got !== handle) return null;
        return card.outerHTML;
      })
      .catch(function () { return null; });
    return cache[handle];
  }

  /* Beperkte parallelliteit, volgorde van het resultaat = volgorde van de invoer. */
  function pool(list, worker, limit) {
    var out = new Array(list.length);
    var next = 0;
    function run() {
      if (next >= list.length) return Promise.resolve();
      var i = next++;
      return Promise.resolve(worker(list[i])).then(function (v) { out[i] = v; return run(); });
    }
    var lanes = [];
    for (var i = 0; i < Math.min(limit, list.length); i++) lanes.push(run());
    return Promise.all(lanes).then(function () { return out; });
  }

  /* ---------------- fail-closed backstop ---------------- */
  /* Kan alleen extra afschermen. Draait ALTIJD, ook als de server het al goed
     deed — dat is de bedoeling van een backstop: hij is stil zolang hij niets
     vindt. Vindt hij wél iets, dan is er een serverfout en is dit het vangnet. */
  function scrubGate(card) {
    var b2b = document.body.dataset.b2b === '1';
    var loggedIn = document.body.dataset.loggedIn === '1';
    var g = grid();
    var wall = !!(g && g.dataset.guestWall === '1');

    /* `data-cust` is de B2B-inkoopprijs en hoort alleen bij een b2b-klant in de
       HTML te staan (snippets/product-card.liquid). Niet-b2b → attribuut weg. */
    if (!b2b) {
      var custs = card.querySelectorAll('[data-cust]');
      for (var i = 0; i < custs.length; i++) custs[i].removeAttribute('data-cust');
    }

    if (loggedIn || !wall) return;      // zachte muur geldt alleen voor een gast
    var priced = card.querySelector('.price[data-price]');
    if (!priced) return;                // server hield het bedrag al weg: klaar

    var onRequest = false;
    try { onRequest = JSON.parse(card.getAttribute('data-product')).priceOnRequest === true; } catch (e) {}
    var href = onRequest ? '/pages/contact' : '/account/login';
    var label = onRequest ? T('common.price_on_request', 'Prijs op aanvraag') : T('common.login_for_prices', 'Log in voor prijzen');
    var addClass = onRequest ? ' pcard__add--quote' : '';
    var addInner = onRequest ? T('common.quote', 'Offerte') : ACCOUNT_ICON;
    var foot = card.querySelector('.pcard__foot');
    if (!foot) return;
    foot.innerHTML =
      '<a class="price__login" href="' + href + '">' + esc(label) + '</a>' +
      '<a class="pcard__add' + addClass + '" href="' + href + '" aria-label="' + esc(label) + '">' + addInner + '</a>';
  }

  /* ---------------- render ---------------- */
  var seq = 0;

  function showEmpty(on) {
    var empty = document.getElementById('wishEmpty');
    if (empty) empty.classList.toggle('hide', !on);
  }

  function render() {
    var g = grid();
    if (!g) return;
    var mine = ++seq;
    var list = handles();
    if (!list.length) { g.innerHTML = ''; showEmpty(true); return; }
    showEmpty(false);
    g.setAttribute('aria-busy', 'true');

    return pool(list, fetchCard, MAX_PARALLEL).then(function (htmls) {
      if (mine !== seq) return;                    // een nieuwere render won
      g.removeAttribute('aria-busy');
      var frag = document.createDocumentFragment();
      var missing = [];
      for (var i = 0; i < list.length; i++) {
        if (!htmls[i]) { missing.push(list[i]); continue; }
        var host = document.createElement('div');
        host.innerHTML = htmls[i];
        var card = host.firstElementChild;
        if (!card) { missing.push(list[i]); continue; }
        /* Het hartje staat op de verlanglijst per definitie AAN. */
        var fav = card.querySelector('[data-wish]');
        if (fav) fav.classList.add('is-active');
        scrubGate(card);
        frag.appendChild(card);
      }
      g.innerHTML = '';
      g.appendChild(frag);
      /* Handles waarvoor de winkel geen kaart levert, verdwijnen uit de lijst —
         stil, zonder her-render (prune roept geen subscribers aan). */
      if (missing.length && window.OlmiaWishlist && OlmiaWishlist.prune) OlmiaWishlist.prune(missing);
      if (!g.children.length) { showEmpty(true); return; }
      if (window.OlmiaUI && OlmiaUI.paintPrices) OlmiaUI.paintPrices(g);
      if (window.OlmiaWishlist && OlmiaWishlist.syncUI) OlmiaWishlist.syncUI();
      if (window.revealScope) window.revealScope(g);
    });
  }

  /* Subscribe exactly once, ever: an editor re-render calls init() again but must
     not add a second render subscription (which would double every wishlist paint). */
  var subscribed = false;
  function init() {
    render();
    if (!subscribed && window.OlmiaWishlist && OlmiaWishlist.subscribe) { subscribed = true; OlmiaWishlist.subscribe(render); }
  }

  /* Editor re-render: het raster is vervangen, dus opnieuw ophalen en tekenen.
     De cache blijft staan — dezelfde pagina, dezelfde serverpoort. */
  if (window.OlmiaEditor) OlmiaEditor.register({
    key: 'olmia-wishlist-page',
    match: function (r) { return !!(r && r.querySelector && r.querySelector('#wishGrid')); },
    init: function () { init(); },
    teardown: function () {}
  });

  /* window.OlmiaWishlist is defined by olmia-wishlist.js, a deferred global that
     sits AFTER {{ content_for_layout }} in layout/theme.liquid — so this deferred
     section script would otherwise run first (readyState 'interactive') and race
     it, painting the empty state and never subscribing. Wait for the global:
     deferred scripts all execute before DOMContentLoaded, so by that event the
     global is guaranteed present. Poll as a last resort if the page is already
     fully loaded when we run. */
  function boot() {
    if (window.OlmiaWishlist) { init(); return; }
    if (document.readyState === 'loading' || document.readyState === 'interactive') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      if (window.OlmiaWishlist || ++tries > 60) { clearInterval(timer); init(); }
    }, 16);
  }
  boot();
})();
